import React from "react";
import {  MDBRow, MDBCol, MDBIcon, MDBBadge } from "mdbreact";
import ProgressiveImage from 'react-progressive-image';

const Team = ({teamData}) => {

  const team = teamData.map((member)=>
    <>
    <MDBCol lg="3" md="3" className="mb-lg-0 mb-5">
      <div>
        <ProgressiveImage src={member.image.url} placeholder={member.image.formats.thumbnail.url}>
        {(src, loading) => (<img
            tag="img"
            style={{ filter: loading && "blur(10px)" }}
            src={src}
            className="rounded-circle w-100 img-fluid"
            alt="Sample avatar"
          />)}
        </ProgressiveImage>
      </div>
      <div className="team-wrappper my-4">
        <h6 className="h6-responsive font-weight-bold my-4 text-uppercase">
          <MDBBadge color="dark" className="p-2">{member.job}</MDBBadge>
        </h6>
        <h3 className="font-weight-bold h3-responsive mt-4 mb-2">{member.name}</h3>
        <p className="grey-text">
          {member.bio}
        </p>
        <div className="d-flex justify-content-center mb-0">
          {member.facebook && <a href={`${member.facebook}`} className="p-2">
            <MDBIcon fab icon="facebook-f" className="black-text" size="lg"/>
          </a>}
          {member.github && <a href={member.github} className="p-2">
            <MDBIcon fab icon="github" className="black-text" size="lg" />
          </a>}
          {member.twitter && <a href={`${member.twitter}`} className="p-2">
            <MDBIcon fab icon="twitter" className="black-text" size="lg" />
          </a>}
          {member.pinterest && <a href={member.pinterest} className="p-2">
            <MDBIcon fab icon="pinterest-p" className="black-text" size="lg" />
          </a>}
          {member.instagram && <a href={`${member.instagram}`} className="p-2">
            <MDBIcon fab icon="instagram" className="black-text" size="lg" />
          </a>}
          {member.linkedin && <a href={member.linkedin} className="p-2">
            <MDBIcon fab icon="linkedin-in" className="black-text" size="lg" />
          </a>}
        </div>
      </div>
    </MDBCol>
    </>
  )

  return (
    <>
    <div className="wrapper text-center">
      <h1 className="display-3 menu-mobile-style text-capitalize font-weight-bold my-5">
        minimuni family
      </h1>
      <MDBRow className="mt-5 pt-5 justify-content-center">
        {team}
      </MDBRow>
    </div>
    </>
  );
}

export default Team;